import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
//import { Http, Response } from '@angular/http';
// creation and utility methods
import { Observable, of, forkJoin } from 'rxjs';
import { environment } from 'environments/environment';
import { ResultDetails } from '../../models/result-details';
import { DocumentEntity } from '../../models/document-entity';
import { DocumentConfigurationModel } from '../../models/document-configuration-model';
import { DocumentConfiguration } from '../../Uploader/Models/DocumentConfiguration';

@Injectable({
  providedIn: 'root'
})

export class DocumentService {
  private documentServiceUrl: string;
  DocumentEntities: { [id: number]: DocumentConfiguration[]; } = {};
  constructor(private http: HttpClient) {
    this.DocumentEntities = {};
    this.documentServiceUrl = environment.document_getDocumentConfiguration;
  }
  GetDocumentConfigurationById(DocumentEntities: DocumentEntity[]): Observable<boolean> {
    var obersrvablArray: Observable<any>[] = [];
    for (var i = 0; i < DocumentEntities.length; i++) {
      var url = this.documentServiceUrl + '/' + DocumentEntities[i].documentConfiguration;
      obersrvablArray.push(this.http.get<ResultDetails>(url));
    }

    return new Observable<boolean>(observer => {
      forkJoin(obersrvablArray).subscribe(response => {
        this.handleRetrievedLookup(response);
      }, error => {
        this.handleError(error);
        observer.error(false);
      }, () => {
        observer.next(true);
      });
    });

  }
  private handleRetrievedLookup(response: any): void {
    for (var i = 0; i < response.length; i++) {
      let documentModel: DocumentConfigurationModel = response[i].Data;
      if (!this.DocumentEntities[documentModel.DocumentConfigurationKey as number])
        this.DocumentEntities[documentModel.DocumentConfigurationKey as number] = documentModel.DocumentConfigurations;
    }
  } 
  private handleError(error): void {

  }
}
